import React, { Component } from 'react';

var thumbImage = {
  backgroundImage: 'url(https://thumbnailer.mixcloud.com/unsafe/600x600/profile/2/3/5/1/b107-948c-49a6-99fc-ed2f3cac7b84.jpg)',
}

var stackImage1 = {
  backgroundImage: 'url(http://dummyimage.com/512/3300ff/ffffff.png)',
}

var stackImage2 = {
  backgroundImage: 'url(http://dummyimage.com/512/02755e/ffffff.png)',
}

var stackImage3 = {
  backgroundImage: 'url(http://dummyimage.com/512/db7d25/ffffff.png)',
}

const ExampleThumbnails = () =>
  
  <section id="thumbnails">
    <h3 className="section-header">Thumbnails</h3>
    <div className="row">
      <div className="columns medium-16">
        <p className="text-danger"><strong>IMPORTANT</strong> we need to support Retina, so thumbnails need to be at 2x their display size and scaled down.Our max desktop display size is 300x300, so we need images that 600x600. With a breakpoint at 631, Our max mobile size is 600x600, so we'd need images at 1200x1200, which would be the minimum size for uploads.</p>
        
      </div>
    </div>
    <div className="row">
      <div className="medium-16 columns">
        <h3>Flexible Thumbnails</h3>
      </div>
    </div>
    <div className="row medium-up-3">
      <div className="column">
        <h4>.thumbnail.flex</h4>
        <div className="thumbnail flex border" style={thumbImage}>
          <div className="menu">
            <div className="menu-left">
              <i className="fa fa-ellipsis-v"></i>
            </div>
            <div className="menu-right">
              <i className="fa fa-trash-o"></i>
            </div>
          </div>
        </div>
      </div>
      <div className="column">
        <h4>.thumbnail.flex.with-flag</h4>
        <div className="thumbnail flex border with-flag" style={thumbImage}>
          <div className="flag bottom-left">
            <div className="flag-text">New!</div>
          </div>
        </div>
      </div>
      <div className="column">
        <h4>.thumbnail-stack</h4>
        <div className="thumbnail-stack">
          <div className="thumbnail flex with-flag" style={stackImage1}>
            <div className="flag top-right">
              <div className="flag-text">Winner</div>
            </div>
          </div>
          <div className="thumbnail flex" style={stackImage2}></div>
          <div className="thumbnail flex" style={stackImage3}></div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="columns medium-6">
        <h4>.thumbnail.flex message</h4>
        <div className="thumbnail thumbnail-260 flex border withdrawn" style={thumbImage}>
          <div className="message">widthdrawn</div>
        </div>
      </div>
      <div className="columns medium-6">
        <h4>.thumbnail.flex overlay</h4>
        <div className="thumbnail thumbnail-260 flex border overlay" style={thumbImage}>
          <div className="overlay-content">
            <h3>Help [user] improve this design.</h3>
          </div>
        </div>
      </div>
    </div>
  </section>;

export { ExampleThumbnails }



// WEBPACK FOOTER //
// ./styleguide/components/thumbnails.jsx